import { GET_USER_PERMISSIONS, GET_USER_ROLE_SUPERVISORS, LOGOUT } from '../../types'

const initialState = {
  userPermissions: [],
  userRoleSupervisors: []
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_USER_PERMISSIONS: return {
      ...state,
      userPermissions: action.payload
    }
    case GET_USER_ROLE_SUPERVISORS: return {
      ...state,
      userRoleSupervisors: action.payload
    }
    case LOGOUT: return {
      ...state,
      ...initialState
    }
    default: return { ...state }
  }
}
